import { createReducer, on } from '@ngrx/store';
import * as DownloadListAction from './download-list.actions';
import { DownloadListItem } from './download-list.models';

export const DOWNLOAD_LIST_FEATURE_KEY = 'downloadList';

export interface DownloadListState {
  downloadList: DownloadListItem[];
  isDownloadListActive: boolean;
}

export const initialDownloadListState: DownloadListState = {
  downloadList: [],
  isDownloadListActive: false,
};

export const downloadListReducer = createReducer(
  initialDownloadListState,
  on(DownloadListAction.addToDownloadList, (state, { document }) => ({
    ...state,
    downloadList: [...state.downloadList, document],
  })),
  on(DownloadListAction.addPageToDownloadListClicked, (state) => ({
    ...state,
    downloadList: [...state.downloadList],
  })),
  on(DownloadListAction.removeFromDownloadList, (state, { documentId, start_page, end_page, assetId }) => ({
    ...state,
    downloadList: state.downloadList.filter((doc) => {
      // For assets: match by assetId when provided
      if (doc.type === 'asset' && assetId) {
        return doc.assetId !== assetId;
      }
      // For documents/pages: match by documentId, start_page, and end_page, excluding assets
      return !(
        doc.documentId === documentId &&
        doc.start_page === start_page &&
        doc.end_page === end_page &&
        doc.type !== 'asset'
      );
    }),
  })),
  on(DownloadListAction.clearDownloadList, (state) => ({
    ...state,
    downloadList: [],
  })),
  on(DownloadListAction.downloadList, (state) => ({
    ...state,
    isDownloadListActive: true,
  })),
  on(
    DownloadListAction.downloadListSuccess,
    DownloadListAction.downloadListFailure,
    DownloadListAction.cancelDownload,
    (state) => ({
      ...state,
      isDownloadListActive: false,
    })
  ),
  on(DownloadListAction.updateDownloadList, (state, { documents }) => ({
    ...state,
    downloadList: documents,
  })),
  on(DownloadListAction.syncDownloadListFromStorage, (state, { documents }) => ({
    ...state,
    downloadList: documents,
  }))
);
